import { render, staticRenderFns } from "./FormLegend.vue?vue&type=template&id=71c324ce&scoped=true&"
import script from "./FormLegend.vue?vue&type=script&lang=js&"
export * from "./FormLegend.vue?vue&type=script&lang=js&"
import style0 from "./FormLegend.vue?vue&type=style&index=0&id=71c324ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c324ce",
  null
  
)

export default component.exports